import styled from 'styled-components';
import { Link } from 'react-scroll';

export const Wrapper = styled.div`
  width: 100%;
  background: linear-gradient(
    89.81deg,
    #6530cf 0.64%,
    #1032f2 23.92%,
    #83e460 43.07%,
    #efe755 61.69%,
    #df7c36 80.84%,
    #d24237 99.98%
  );
  text-align: center;
  padding: 75px 0 100px;

  .privacyPolicyLink {
    font-family: 'GT America';
    font-weight: 300;
    font-style: italic;
    &:hover {
      color: #e3cc44;
    }
  }
`;

export const Nav = styled.ul`
  li {
    display: inline-block;
    margin: 0 10px;
  }
`;

export const NLink = styled(Link)`
  color: #fff;
  text-transform: uppercase;
  text-decoration: none;
  transition: all 180ms ease-out;
  font-size: 0.8em;
  font-family: 'GT America';
  font-weight: 300;
  font-style: italic;

  &:hover {
    color: #0000ff;
  }
`;

export const RegLink = styled.a`
  color: #fff;
  text-transform: uppercase;
  text-decoration: none;
  transition: all 180ms ease-out;
  font-size: 0.8em;
  font-family: 'GT America';
  font-weight: 300;
  font-style: italic;

  &:hover {
    color: #6530cf;
  }
`;

export const Logo = styled.img`
  margin: 45px 0 0 0;
`;

export const SocialList = styled.ul`
  margin-bottom: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  li {
    display: inline-block;
    margin: 0 20px;
    @media (max-width: 700px) {
      margin: 0 10px;
    }
  }

  a {
    transition: opacity 180ms ease-out;
    line-height: 1.8;
    &:hover {
      opacity: 0.7;
    }
  }
`;

export const FooterLogo = styled.div`
  display: flex;
  flex-direction: column;
  width: 150px;
  margin: 0 auto;

  a {
    margin: 40px 0 0;
    text-transform: uppercase;
    text-decoration: none;
    color: #fff;
    font-size: 1.4em;
    font-size: 0.9em;
    font-family: 'Roboto';
    font-weight: normal;
  }

  button {
    margin-top: 20px;
    background: none;
    color: #fff;
    border: none;
    font-family: 'Tungsten';
    font-weight: 600;
    font-style: normal;
    text-transform: uppercase;
    font-size: 1.1em;
  }
`;
